import { Component, OnInit } from '@angular/core';
import {OregonWellDataService} from '../../../services/oregon-well-data.service'
import { VoucherService } from '../../../services/voucher-service';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'upload-voucher-test-results',
  templateUrl: './upload-voucher-test-results.component.html'
})
export class UploadVoucherTestResultsComponent implements OnInit {
  constructor(public oregonWellService: OregonWellDataService, 
              public voucherService: VoucherService,
               private toastr: ToastrService, 
              public dialog: MatDialog) {
  
  }
  
  ngOnInit() {  
    // ngOnInit
  } 
}